import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import {IconDesktop,IconMobile} from './Icons';
import Settings from './Settings';


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class DeviceSwitcher extends Component{

  @observable trans = {  };

  @observable device = '';

  constructor(props) {

    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;
  }

  componentDidMount(){
    this.device = Settings.getSettingsDevice;

  }

  @action onClick = (val) => {
     // this.device = val;
      Settings.setDevice(val);

  }

  render() {

    const t = this.t;

    return (
      <div className="DeviceSwitcher">
        <div>
        <button  className={( Settings.getSettingsDevice == 'mobile' ? 'active' : '' )}  onClick={ ()=> { this.onClick('mobile') } }>
          <span className="button-inside"><IconMobile/></span>
          <span>{t('Mobile')}</span>
        </button>
        <button className={(Settings.getSettingsDevice == 'desktop' ? 'active' : '' )}  onClick={ ()=> { this.onClick('desktop') } }>
          <span  className="button-inside"><IconDesktop/></span>
          <span>{t('Desktop')}</span>
        </button>
        </div>
      </div>
    );

  }
}


